import AsyncSelect from 'Shared/components/AsyncSelect'
import Step from './Step'

function EffortShortDescriptor({ complete, effortName }) {
  return (
    <div>
      {complete && <div>
        <p className='no-margin-bottom'>This campaign is part of the <b>{effortName}</b> goal.</p>
      </div>}
      {!complete && <p className='incomplete no-margin-bottom'>(Optional) Select a goal that this campaign is working toward.</p>}
    </div>
  )
}

const Effort = () => {
  const act = useAct()
  const answers = useSel((s) => s.answers.entities)
  const [multipleGoalsWarning, setMultipleGoalsWarning] = useState(false)

  const {
    effort: { id, name } = {}
  } = useSel(s => s.campaign)

  const complete = !!name

  const updateEffort = (e, objs) => {
    if (objs?.goals?.length > 1 && Object.values(answers).some(a => a.setsGoalId) && e !== id) {
      setMultipleGoalsWarning(true)
    } else {
      setMultipleGoalsWarning(false)
    }
    act.campaign.upsert({
      effortId: e,
      effort: { id: e, name: objs?.label },
    })
  }

  const clearEffort = () => {
    updateEffort(null, null)
  }

  return <Step
    name='Goal'
    editor='effort'
    complete={complete}
    shortDescriptor={<EffortShortDescriptor complete={complete} effortName={name} />}
  >
    <div className='row'>
      <div className='column two-thirds'>
        <AsyncSelect
          entity='effort'
          value={id}
          loadStaticList={true}
          queryParameters={{ kept: 1 }}
          onChange={updateEffort}
          classNamePrefix="effort-select"
        />
        {id && <>
          { multipleGoalsWarning ?
            <p className="error">This goal has multiple sub-goals. You have answers in your script that mark sub-goals complete. These will be cleared and you will need to re-select any sub-goals for answers you want marked complete.</p>
            : <br />
          }
          <a href="#" onClick={clearEffort} className="blue-link">Clear</a>
        </>}
      </div>

      <div className='column third'>
        <p className='no-margin-top'>
          Goals optionally let you organise campaigns into long-running organisational initiatives.
          For example, a campaign might be part of an 'Indicative strike ballot' goal.
        </p>
      </div>
    </div>
  </Step>
}

export default Effort
